import { render } from "./SpellDesc.vue?vue&type=template&id=0d042bfb&scoped=true"
import script from "./SpellDesc.vue?vue&type=script&lang=js"
export * from "./SpellDesc.vue?vue&type=script&lang=js"

import "./SpellDesc.vue?vue&type=style&index=0&id=0d042bfb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d042bfb"]])

export default __exports__